// Personal Dashboard JS - Control Financiero y Tesorería
$(document).ready(function() {
    if ($('.personal-container').length > 0) {
        infopersonal($("#ano-personal").val(), $("#banco-personal").val());
    }
});

$(document).on('change', '#ano-personal', function() {
    infopersonal($("#ano-personal").val(), $("#banco-personal").val());
});

// Click en botones de filtro por banco
$(document).on('click', '.btn-filtro-banco', function() {
    $('.btn-filtro-banco').removeClass('btn-primary active').addClass('btn-outline-secondary');
    $(this).removeClass('btn-outline-secondary').addClass('btn-primary active');
    
    const bancoId = $(this).data('banco');
    $("#banco-personal").val(bancoId);
    infopersonal($("#ano-personal").val(), bancoId);
});

// Click en tarjetas superiores de bancos
$(document).on('click', '.card-banco-interactive', function() {
    const bancoId = $(this).data('banco-id');
    $(`.btn-filtro-banco[data-banco="${bancoId}"]`).trigger('click');
});

function infopersonal(ano, banco_id) {
    banco_id = banco_id || $("#banco-personal").val() || 'global';
    
    $.ajax({
        url: '/home/infopersonal/' + ano + '?banco_id=' + banco_id,
        type: 'GET',
        success: function(response) {
            // Actualizar tarjetas superiores de bancos
            if (response.bancos_cards) {
                response.bancos_cards.forEach(function(b) {
                    $(`#card-saldo-banco-${b.id}`).text(b.saldo_actual + " €");
                });
            }
            if (response.patrimonio_total) {
                $("#card-patrimonio-total").text(response.patrimonio_total + " €");
            }

            // Actualizar métricas del filtro seleccionado
            $("#personal-saldo-banco").text(response.saldo_actual_hoy + " €");
            $("#personal-ingresos-anuales").text("+" + response.ingresos_anuales + " €");
            $("#personal-gastos-anuales").text("-" + response.gastos_anuales + " €");
            $("#personal-ahorro-anual").text(response.ahorro_anual + " €");
            $("#personal-tasa-ahorro").text(response.tasa_ahorro_anual);

            // Actualizar badge de información de cuenta
            if (banco_id === 'global') {
                $("#badge-cuenta-info").html('<i class="bi bi-globe2 me-1 text-primary"></i> Viendo consolidado global de tesorería (3 cuentas)');
            } else {
                const activeBtn = $(`.btn-filtro-banco[data-banco="${banco_id}"]`).text().trim();
                $("#badge-cuenta-info").html(`<i class="bi bi-bank me-1 text-primary"></i> Viendo cuenta: <strong>${activeBtn}</strong>`);
            }

            // Pintar tabla de desglose mensual
            if (response.meses_desglose) {
                let htmlTabla = '';
                const currentMonth = new Date().getMonth() + 1;
                const currentYear = new Date().getFullYear();

                response.meses_desglose.forEach(function(mes) {
                    let flujoClase = mes.es_positivo ? 'text-success fw-bold' : 'text-danger fw-bold';
                    let flujoSigno = mes.es_positivo ? '+' : '';
                    
                    let rowStyle = '';
                    let statusBadge = '';
                    
                    if (ano < currentYear) {
                        rowStyle = 'background-color: rgba(25, 135, 84, 0.02);';
                        statusBadge = '<span class="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-2 py-1 small fw-semibold" style="font-size:0.7rem;"><i class="bi bi-check-circle-fill me-1"></i> Cerrado</span>';
                    } else if (ano > currentYear) {
                        rowStyle = 'opacity: 0.65;';
                        statusBadge = '<span class="badge bg-secondary bg-opacity-10 text-secondary border px-2 py-1 small fw-semibold" style="font-size:0.7rem;"><i class="bi bi-clock me-1"></i> Previsto</span>';
                    } else {
                        if (mes.numero < currentMonth) {
                            rowStyle = 'background-color: rgba(25, 135, 84, 0.02);';
                            statusBadge = '<span class="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-2 py-1 small fw-semibold" style="font-size:0.7rem;"><i class="bi bi-check-circle-fill me-1"></i> Cerrado</span>';
                        } else if (mes.numero === currentMonth) {
                            rowStyle = 'background-color: rgba(13, 110, 253, 0.05); border-left: 4px solid #0d6efd !important;';
                            statusBadge = '<span class="badge bg-primary text-white px-2 py-1 small fw-semibold" style="font-size:0.7rem;"><i class="bi bi-record-circle me-1"></i> En curso</span>';
                        } else {
                            rowStyle = 'opacity: 0.7;';
                            statusBadge = '<span class="badge bg-secondary bg-opacity-10 text-secondary border px-2 py-1 small fw-semibold" style="font-size:0.7rem;"><i class="bi bi-clock me-1"></i> Previsto</span>';
                        }
                    }

                    // Botón para ajustar recibos reales del mes
                    let btnEdit = (ano <= currentYear && (ano < currentYear || mes.numero <= currentMonth)) 
                        ? `<button class="btn btn-sm btn-light border p-1 ms-2 btn-ajustar-mes" data-mes="${mes.numero}" data-nombre="${mes.nombre}" title="Ajustar importes reales pagados este mes"><i class="bi bi-pencil text-primary" style="font-size: 0.75rem;"></i></button>`
                        : '';

                    // Construir subtítulo de entradas
                    let detalleEntradas = [];
                    if (parseFloat(mes.ingresos_negocio.replace(/\./g, '').replace(',', '.')) > 0) {
                        detalleEntradas.push(`Actividad: ${mes.ingresos_negocio} €`);
                    }
                    if (parseFloat(mes.transferencias_in.replace(/\./g, '').replace(',', '.')) > 0) {
                        detalleEntradas.push(`Traspasos In: +${mes.transferencias_in} €`);
                    }
                    if (parseFloat(mes.otros_ingresos.replace(/\./g, '').replace(',', '.')) > 0) {
                        detalleEntradas.push(`Extras: ${mes.otros_ingresos} €`);
                    }
                    let txtEntradas = detalleEntradas.length > 0 ? detalleEntradas.join(' • ') : 'Sin cobros registrados';

                    // Construir subtítulo de salidas
                    let detalleSalidas = [];
                    if (parseFloat(mes.total_negocio_gastos.replace(/\./g, '').replace(',', '.')) > 0) {
                        detalleSalidas.push(`Negocio: ${mes.total_negocio_gastos} €`);
                    }
                    if (parseFloat(mes.total_personal_gastos.replace(/\./g, '').replace(',', '.')) > 0) {
                        detalleSalidas.push(`Hogar/Personal: ${mes.total_personal_gastos} €`);
                    }
                    if (parseFloat(mes.impuestos_liquidados.replace(/\./g, '').replace(',', '.')) > 0) {
                        detalleSalidas.push(`Hacienda: ${mes.impuestos_liquidados} €`);
                    }
                    if (parseFloat(mes.transferencias_out.replace(/\./g, '').replace(',', '.')) > 0) {
                        detalleSalidas.push(`Traspasos Out: -${mes.transferencias_out} €`);
                    }
                    let txtSalidas = detalleSalidas.length > 0 ? detalleSalidas.join(' • ') : 'Sin pagos registrados';

                    htmlTabla += `
                        <tr style="${rowStyle}">
                            <td class="text-start ps-3 fw-bold align-middle">
                                <div class="d-flex align-items-center justify-content-between">
                                    <div class="d-flex align-items-center">
                                        <span class="text-slate-900">${mes.nombre}</span>
                                        ${btnEdit}
                                    </div>
                                    ${statusBadge}
                                </div>
                            </td>
                            <td class="align-middle fw-semibold text-muted">${mes.saldo_inicial} €</td>
                            <td class="align-middle text-start">
                                <div class="text-success fw-bold">+${mes.total_entradas} €</div>
                                <div class="text-muted" style="font-size: 0.72rem;">${txtEntradas}</div>
                            </td>
                            <td class="align-middle text-start">
                                <div class="text-danger fw-bold">-${mes.total_salidas} €</div>
                                <div class="text-muted" style="font-size: 0.72rem;">${txtSalidas}</div>
                            </td>
                            <td class="align-middle ${flujoClase}">
                                ${flujoSigno}${mes.neto_flujo} €
                            </td>
                            <td class="align-middle">
                                <span class="badge bg-slate-900 text-white px-3 py-2 fw-bold" style="font-size:0.85rem; border-radius: 8px; min-width: 100px;">
                                    ${mes.saldo_final} €
                                </span>
                            </td>
                        </tr>
                    `;
                });
                $("#tabla-conciliacion-mensual").html(htmlTabla);
            }
        },
        error: function(xhr, status, error) {
            console.error("Error al cargar finanzas personales:", error);
        }
    });
}

// Modal para ajustar importes reales del mes
$(document).on('click', '.btn-ajustar-mes', function() {
    const mes = $(this).data('mes');
    const nombre = $(this).data('nombre');
    const ano = $("#ano-personal").val();

    $("#modal-mes-nombre").text(nombre + " " + ano);
    $("#ajuste-ano").val(ano);
    $("#ajuste-mes").val(mes);
    $("#lista-gastos-ajuste").html('<div class="text-center py-4 text-muted"><div class="spinner-border spinner-border-sm me-2"></div> Cargando gastos...</div>');
    
    var myModal = new bootstrap.Modal(document.getElementById('modalAjusteMes'));
    myModal.show();

    $.ajax({
        url: `/gastos-fijos/valores/${ano}/${mes}`,
        type: 'GET',
        success: function(response) {
            if (response.length === 0) {
                $("#lista-gastos-ajuste").html('<div class="alert alert-info">No hay gastos fijos configurados que apliquen a este mes.</div>');
                return;
            }

            let html = '';
            response.forEach(function(g) {
                const valActual = g.importe_real !== null ? g.importe_real : '';
                const badge = g.tipo === 'negocio' ? '<span class="badge bg-success">Negocio</span>' : '<span class="badge bg-primary">Personal</span>';
                
                html += `
                    <div class="mb-3 p-3 border rounded bg-light">
                        <div class="d-flex justify-content-between mb-2">
                            <label class="fw-bold text-slate-800">${g.nombre} ${badge}</label>
                            <span class="text-slate-500 small">Estimado: ${parseFloat(g.importe_estimado).toFixed(2)} €</span>
                        </div>
                        <div class="input-group">
                            <span class="input-group-text bg-white"><i class="bi bi-currency-euro"></i></span>
                            <input type="number" step="0.01" class="form-control input-gasto-ajuste" data-id="${g.id}" placeholder="${parseFloat(g.importe_estimado).toFixed(2)}" value="${valActual}">
                        </div>
                    </div>
                `;
            });

            $("#lista-gastos-ajuste").html(html);
        }
    });
});

$(document).on('click', '#btnGuardarAjusteMes', function() {
    const ano = $("#ajuste-ano").val();
    const mes = $("#ajuste-mes").val();
    const valores = [];

    $(".input-gasto-ajuste").each(function() {
        valores.push({
            id: $(this).data('id'),
            importe_real: $(this).val()
        });
    });

    const btn = $(this);
    btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm me-2"></span> Guardando...');

    $.ajax({
        url: `/gastos-fijos/valores/${ano}/${mes}`,
        type: 'POST',
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
            valores: valores
        },
        success: function(response) {
            btn.prop('disabled', false).html('<i class="bi bi-save me-1"></i> Guardar Ajustes');
            var myModalEl = document.getElementById('modalAjusteMes');
            var modal = bootstrap.Modal.getInstance(myModalEl);
            modal.hide();
            
            infopersonal(ano, $("#banco-personal").val());
            
            if (typeof Swal !== 'undefined') {
                Swal.fire({
                    icon: 'success',
                    title: 'Ajustes Guardados',
                    text: 'El mes ha sido recalculado con los importes reales.',
                    timer: 2000,
                    showConfirmButton: false
                });
            }
        },
        error: function(xhr) {
            btn.prop('disabled', false).html('<i class="bi bi-save me-1"></i> Guardar Ajustes');
            if (typeof Swal !== 'undefined') {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudieron guardar los ajustes.'
                });
            }
        }
    });
});
